import ContentArea from '@episerver/spa-core/Components/ContentArea';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import InternetComplementaryProductListBlockData from 'app/Models/Content/InternetComplementaryProductListBlockData';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import React from 'react';

const InternetComplementaryProductListBlock = (props: ComponentProps<InternetComplementaryProductListBlockData>) => {
  const {data, context} = props;
  return (
    <BlockWrapper props={props}>
      <div className='InternetComplementaryProductListBlock'>
        <ContentArea noWrap data={data.internetComplementaryProducts} context={context} />
      </div>
    </BlockWrapper>
  );
};

export default InternetComplementaryProductListBlock;
